// @flow

import styled from 'styled-components';

export const AnimatedContentContainer = styled.div`
    display: flex;
    flex-grow: 1;
    width: 100%;
`;

export const AnimatedContent = styled.div`width: 100%;`;



// WEBPACK FOOTER //
// ./src/components/widgets/load-transition/styles.js